import { Booking } from '@collinsonx/utils';
import { GUEST_TYPES } from 'config/productDefaultConfig';
import { Booking as BookingState } from 'context/BookingContext';
import { filterMissingProperties } from 'utils/stateManagement';

export const convertBookingToBookingState = (
  booking?: Booking
): Partial<BookingState> => {
  const parsedBooking = {
    bookingId: booking?.id,
    currentPrice: booking?.price,
    departureDate: booking?.bookedFrom ? new Date(booking?.bookedFrom) : null,
    existing_booking_slot: booking?.bookedFrom,
    flightNumber: booking?.metadata?.flightNumber,
    flightTime: booking?.metadata?.flightTime,
    [GUEST_TYPES.adults]: booking?.guestAdultCount,
    [GUEST_TYPES.children]: booking?.guestChildrenCount,
    [GUEST_TYPES.infants]: booking?.guestInfantCount,
    reference: booking?.reference,
    taxableGuestsCount:
      (booking?.guestAdultCount ?? 0) + (booking?.guestChildrenCount ?? 0),
    usedEntitlements: booking?.usedEntitlementsCount,
  };

  return filterMissingProperties(parsedBooking);
};
